import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
/**
 * Custom hook that manages the active tab based on the URL hash.
 * @param fragments - An array of strings that represent the hash fragment for the corresponding tab index.
 * @returns An array containing the active tab and a function to set the active tab.
 */
export const useTabNavigation = (fragments = []) => {
    const { pathname, hash, search } = useLocation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(() => {
        const idx = hash ? fragments.indexOf(hash) : 0;
        return idx !== -1 ? idx : 0;
    });
    useEffect(() => {
        const nextHash = fragments[activeTab] || '';
        // Navigating to the current URL would still drop its `state` and entry key.
        if (hash === nextHash) {
            return;
        }
        navigate({
            pathname,
            hash: nextHash,
            search,
        }, 
        // A tab change adds a history entry; filling in a missing or unknown hash on mount replaces it,
        // so the first Back doesn't stay on the page.
        { replace: !fragments.includes(hash) });
    }, [activeTab]);
    return [activeTab, setActiveTab];
};
